export const AUTH_KEY = 'isa-auth';
export const TOKEN_KEY = 'isa-token';
export const REFRESH_KEY = 'isa-refresh-token';
export const AUTH_EVENT = 'isa-auth-change';
export const AUTH_INFO_KEY = 'isa-auth-info';